<template>
  <app-step>
    <nights-two-columns>
      <template v-slot:left>
        <div v-if="!isPackFlight">
          <h1>{{ $t('shared.extras') }}</h1>
          <div class="space-y-6">
            <app-box-booking
              v-for="(item, index) in extrasIncluded"
              :key="index"
              class="px-6"
            >
              <app-box-icon
                :avatar="item.avatar"
                :title="item.title"
                :copy="item.copy"
              ></app-box-icon>
            </app-box-booking>
          </div>
        </div>

        <flex-extras :travelers-total="getPassengersCount"></flex-extras>

        <div v-if="!isPackFlight">
          <div class="extras-personalize mt-5" v-if="extras.length !== 0">
            <div class="flex items-center justify-between">
              <h3 class="heading-3 w-full">
                {{$t("shared.personalize_trip")}}
              </h3>
              <hr class="w-full hidden xl:block" />
            </div>
            <div class="mt-12 space-y-6">
              <app-box-booking
                v-for="extra in extras"
                :key="extra.id"
                class="px-6"
              >
                <app-box-checkbox
                  :id="extra.id"
                  :slug="extra.slug"
                  :selected="!!getSelectedExtraById(extra.id)"
                  :title="extra.title"
                  :copy="extra.description"
                  :isCuatitative="extra.has_counter === 1"
                  :counter-is-disabled="! getSelectedExtraById(extra.id)"
                  :quantity="extraQuantity(extra.id)"
                  :price="getExtraPrice(extra.id)"
                  :counter-max-value="getPassengersCount"
                  :counter-min-value="1"
                  v-on:checkboxChange="toggleExtra(extra.id)"
                  v-on:counterChange="changeExtraQuantity"
                />
              </app-box-booking>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:right>
        <div class="summary-container space-y-5 w-full">
          <box-summary :selectedCategory="selectedCategory" :packHotels="packHotels" :extraNoPromoPercentage="extraNoPromoPercentage" :totalPrice="totalPrice" :totalPriceLuxury="totalPriceLuxury">
            <v-btn
              rounded
              light
              elevation="0"
              block
              color="secondary"
              class="hidden xl:block avm-btn mx-auto"
              :loading="loading"
              @click="goToStep('datos-personales')"
            >
              {{ $t('shared.continue') }}
            </v-btn>
          </box-summary>
        </div>
      </template>
    </nights-two-columns>
  </app-step>
</template>

<script>
import { mapGetters } from "vuex";
import BoxSummary from "../common/BoxSummary.vue";
import NightsTwoColumns from "../common/NightsTwoColumns.vue";
import {
  NIGHTS_GET_PASSENGERS_COUNT,
  NIGHTS_GET_EXTRA_BY_ID,
  NIGHTS_GET_EXTRA_UNIT_PRICE,
  NIGHTS_GET_SELECTED_EXTRA_BY_ID,
  NIGHTS_GET_IS_PACK_FLIGHT,
  NIGHTS_GET_LUXURY_EXTRA,
  NIGHTS_GET_TOTAL_PRICE_PACK_LUXURY,
  NIGHTS_GET_TOTAL_PRICE_PACK_STANDARD,
  NIGHTS_GET_SELECTED_CATEGORY,
  NIGHTS_GET_PACK_HOTELS,
  GET_EXTRA_NO_PROMO_PRICE,
} from "../../../store/nights/getter-types";
import {
  NIGHTS_SET_EXTRA_QUANTITY,
  NIGHTS_TOGGLE_EXTRA,
} from "../../../store/nights/mutation-types";
import { goToStep } from "../mixins";
import FlexExtras from "../../../components/FlexExtras.vue";

export default {
  mixins: [goToStep],
  components: {
    BoxSummary,
    FlexExtras,
    NightsTwoColumns
  },
  data() {
    return {
      extrasIncluded: [
        {
          avatar: {
            icon: "/img/icons/checkin-black.svg",
            size: 48,
          },
          copy: this.$t('shared.recive_cards_24'),
          title: this.$t('shared.check_in_included'),
        },
        {
          avatar: {
            icon: "/img/icons/bag.svg",
            size: 48,
          },
          copy: this.$t('shared.you_may_carry_a_bag'),
          title: this.$t('shared.handbag_included'),
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      getPassengersCount: NIGHTS_GET_PASSENGERS_COUNT,
      getExtraById: NIGHTS_GET_EXTRA_BY_ID,
      getSelectedExtraById: NIGHTS_GET_SELECTED_EXTRA_BY_ID,
      getExtraPrice: NIGHTS_GET_EXTRA_UNIT_PRICE,
      isPackFlight: NIGHTS_GET_IS_PACK_FLIGHT,
      packHotels: NIGHTS_GET_PACK_HOTELS,
      selectedCategory:NIGHTS_GET_SELECTED_CATEGORY,
      totalPrice: NIGHTS_GET_TOTAL_PRICE_PACK_STANDARD,
      totalPriceLuxury: NIGHTS_GET_TOTAL_PRICE_PACK_LUXURY,
      extraLuxury: NIGHTS_GET_LUXURY_EXTRA,
      extraNoPromoPercentage: GET_EXTRA_NO_PROMO_PRICE
    }),
    loading() {
      return this.$store.state.nights.loading;
    },
    extras() {
      return this.$store.state.nights.resources.extras;
    }
  },
  methods: {
    extraQuantity(extraId) {
      const extra = this.getSelectedExtraById(extraId);
      if (!extra) return 0;
      return extra.has_counter ? extra.quantity : 0;
    },
    toggleExtra(extraId) {
      this.$store.commit(NIGHTS_TOGGLE_EXTRA, extraId);
    },
    changeExtraQuantity(quantity, extraId) {
      this.$store.commit(NIGHTS_SET_EXTRA_QUANTITY, { quantity, extraId });
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";

.time-left {
  background-color: $navy;
  width: 100%;
  height: fit-content;
  border-radius: 15px;
  padding: 1rem;

  p {
    color: $white;
    margin-left: 1rem;
    font-size: 16px;
  }
}
</style>
